// The monthly payment slider works in whole dollars: its value is shown on the deposit confirmation and sent to the server
// as the desired payment, so both of its bounds must resolve to the integers that are displayed. The configured minimum is
// rounded up so the slider never offers a whole-dollar value below it.
export const getEffectiveMinMonthlyPayment = (minMonthlyPayment: number): number =>
  Math.ceil(minMonthlyPayment);

// The server applies paymentPercentOfMonthlyIncome against monthly income to produce maxMonthlyPayment.
// The client applies the same percentage against the selected down payment as a secondary cap.
// The cap is floored to a whole dollar and never drops below the effective minimum, so the slider range is never reversed.
export const getEffectiveMaxMonthlyPayment = (
  minMonthlyPayment: number,
  maxMonthlyPayment: number,
  paymentPercentOfMonthlyIncome: number | null | undefined,
  selectedDownPayment: number
): number => {
  const cappedMax = paymentPercentOfMonthlyIncome
    ? Math.min(maxMonthlyPayment, paymentPercentOfMonthlyIncome * selectedDownPayment)
    : maxMonthlyPayment;
  return Math.max(getEffectiveMinMonthlyPayment(minMonthlyPayment), Math.floor(cappedMax));
};
